import crudActionCreators from './crudActionCreators';

const cac = new crudActionCreators('designation', '/admin/designations');

export const loadAction = cac.loadAction;
export const addAction = cac.addAction;
export const deleteAction = cac.deleteAction;
export const putAction = cac.putAction;
export const updateAction = cac.updateAction;
